export * from './mergeRichText';
